/** @module SiteAdmin/SelectSet/StructureItemsTable */
define([
	"dojo/_base/declare",
	"csi/table/Widget",
	"./_StructureItemsMixin"
], function(declare,TableWidget,_StructureItemsMixin) {

	return declare([TableWidget,_StructureItemsMixin]);
});